import { render, staticRenderFns } from "./ViewSettingsGroupHead.vue?vue&type=template&id=4d902a0b&scoped=true&"
import script from "./ViewSettingsGroupHead.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsGroupHead.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsGroupHead.vue?vue&type=style&index=0&id=4d902a0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d902a0b",
  null
  
)

export default component.exports